import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DeletedGroupService {

  // Group deleted logic
  private groupDeletedSource = new Subject<number>();
  groupDeleted$ = this.groupDeletedSource.asObservable();

  notifyGroupDeleted(id: number) {
    this.groupDeletedSource.next(id);
  }

}
